import { driver, ActionType } from "./types";

const setDriver = (data: driver) => {
  return {
    type: ActionType.SET_DRIVER,
    payload: data,
  };
};

export default setDriver;
